import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

const breakpoints = [440, 768, 1024, 1200, 1400]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

export const Wrap = styled.div`
  padding: 80px 0 100px;
  background: var(--color-grayscale-900);
`

const contentMQ = css(mq({
  maxWidth: [
    "calc(100vw - 32px)", // 0+
    "calc(100vw - 32px)", // 440+
    "calc(100vw - 64px)", // 768+
    "calc(100vw - 80px)", // 1024+
  ],
  gap: [
    12, // 0+
    12, // 440+
    12, // 768+
    44, // 1024+
  ],
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 1260px;
  margin: 0 auto;
  ${contentMQ}
`

const titleMQ = css(mq({
  font: [
    "var(--accent-770)", // 0+
    "var(--accent-770)", // 440+
    "var(--accent-970)", // 768+
  ],
}))

export const Title = styled.h2`
  color: var(--color-white);
  ${titleMQ}
`
